//多平台
export default {
  getName(value) {
    var names = [{ value: "pdd", text: "拼多多" }, { value: "douyin", text: "抖音" }];
    var result = names.find(x => x.value == value);
    console.log("result", result)
    return result ? result.text : "";
  },
  getPlatformObject(data) {
    var sys_type = "ali"; //localStorage.getItem("sys_type");
    var obj = {}
    switch (sys_type) {
      case "pdd":
        obj = { ...data, orderSn: data.orderNumber };
        if (data.items.length > 0) {
          obj = { ...obj, ...data.items[0] }
        }
        break;
      case "douyin":
        break
      default:
        break;
    }
    return JSON.parse(JSON.stringify(obj));
  },
  getPddObj(url) {
    var obj = {};

    var data = {
      freeprint: {
        editDialog: {
          id: 0,
          isPrint: false,
          type: 10, // 10：自定义，20：关联
          orderSn: "", // 订单号
          goodsName: "", // 商品名称
          goodsCount: null, // 商品数量
          goodsWeight: null, // 重量
          note: "", // 备注
          receiverAddress: {
            country: "",
            province: "",
            city: "",
            district: "",
            street: "",
            detailAddress: "",
            postalCode: "",
            fullName: "",
            mobilePhone: "",
          },
          addressCode: "",
        }
      }
    }

    obj = { ...data };
    var urls = url.split(".");
    urls.forEach(x => obj = obj[x]);

    return obj;
  },
}